export const DAN_XUAN = '1'
export const DUO_XUAN = '2'
export const TIAN_KONG = '0'
